// extracted by mini-css-extract-plugin
export default {"checkBoxLabel":"styles_checkBoxLabel__wP0Pz","checkBoxWrapper":"styles_checkBoxWrapper__jrSqC","label":"styles_label__QfsYW"};